/**
 * TopBar — the single 60px chrome row (design_handoff_navigation_shell §2).
 * Wordmark and the utility cluster. Global search is designed but not built: its
 * markup stays behind SHOW_SEARCH so re-enabling it is a flag, not a rebuild.
 *
 * SCOPE LEFT THIS BAR ON 19 AUG 2026 (Mike). One global entity/grain/period group
 * forced every page to share axes that not every page has: Capacity has no year and
 * no month/week grain, and Margin's Weekly asked Sage for a week it does not keep.
 * Each page now declares its own axes in a ScopeBar under its title. The header
 * carries identity, and identity alone.
 */

import React from 'react'
import Sym from './Sym'
import { PRODUCT_NAME, SHOW_SEARCH } from '../config/shell'

const CONTROL = 'cx-btn flex h-[34px] items-center rounded-[9px] border border-line'

function SearchBox(): React.JSX.Element {
  return (
    <button className={`${CONTROL} max-w-[520px] flex-1 gap-2.5 bg-panel2 px-3 text-left text-mut2`}>
      <Sym name="search" size={18} />
      <span className="text-[13px]">Find a metric, resource or order…</span>
      <span className="ml-auto rounded-[5px] border border-line bg-panel px-1.5 py-px font-mono text-[10px] text-mut2">
        ⌘K
      </span>
    </button>
  )
}

/** No unread dot: there is no notification feed yet, and a fake signal is a lie. */
function Notifications(): React.JSX.Element {
  return (
    <button
      disabled
      title="Notifications — not yet wired"
      aria-label="Notifications — not yet wired"
      className="flex h-[34px] w-[34px] items-center justify-center rounded-[9px] text-mut2 opacity-60"
    >
      <Sym name="notifications" size={20} />
    </button>
  )
}

export default function TopBar(): React.JSX.Element {
  return (
    // print:hidden — S4: the printed sign-off pack is the document alone
    <header className="print:hidden sticky top-0 z-30 flex h-[60px] items-center gap-4 border-b border-line bg-panel pl-[18px] pr-5">
      {/* Quiet on purpose: the page title is the loud thing in this column, and the
          wordmark must not compete with it. Weight and colour drop, not size alone. */}
      <div className="min-w-[186px] whitespace-nowrap text-[14px] font-medium tracking-[.01em] text-mut">
        {PRODUCT_NAME}
      </div>

      {SHOW_SEARCH && <SearchBox />}

      <div className="ml-auto flex items-center gap-4">
        <Notifications />
      </div>
    </header>
  )
}
